import request from "@/utils/request";

// 获取采购单列表
export function getList(data) {
  return request.post("/wms/tobuy/info/queryPage", data);
}

export function edit(data) {
  return request.post(
    `/wms/tobuy/info/${data.id ? "updateById" : "insert"}`,
    data
  );
}

export function del(id) {
  return request.get("/wms/tobuy/info/deleteById/" + id);
}

export function findById(id) {
  return request.get("/wms/tobuy/info/findById/" + id);
}
